import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const SUPPORTED_LANGUAGES = ["ru", "en", "et", "es"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

const fallbackLng: SupportedLanguage = "en";

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng,
        supportedLngs: SUPPORTED_LANGUAGES,
        ns: ["auth", "admin"],
        defaultNS: "auth",
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json",
        },
        detection: {
            order: ["querystring", "localStorage", "sessionStorage", "navigator", "cookie", "htmlTag"],
            caches: ["localStorage"],
        },
        react: {
            useSuspense: true,
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
